import { Information } from "../../../entities/information";
import InformationInterface from "./informationInterface";
import informationRepository from "../../../../infrastructure/repository/impl/information/information_repository";

class InformationUseCases implements InformationInterface {
  async list(): Promise<Information[]> {
    return await informationRepository.list();
  }

  async listLandingPage(): Promise<Information[]> {
    return await informationRepository.listLandingPage();
  }
}

export default new InformationUseCases() as InformationInterface;
